import request from '../request';

export default {
  // 临时登录
  login(data) {
    return request.post('/user/login', data);
  },

  // 管理员信息
  info(data) {
    return request.get('/user/info', data);
  },

  //获取菜单-SaaS
  getMenus(data) {
    return request.get('/user/menu', data);
  },

  //SaaS账号-新增
  addAdmin(data) {
    return request.post('/user/add', data);
  },

  //SaaS账号-修改
  editAdmin(data) {
    return request.post('/user/edit', data);
  },

  //SaaS账号-列表
  getAdmin(data) {
    return request.get('/user/lists', data);
  },

  //平台账号-删除
  deleteAdmin(data) {
    return request.post('/user/delete', data);
  },

  //SaaS账号-角色数据源
  roleList(data) {
    return request.get('/user/roleList', data);
  },

  //小程序-可用列表
  shopList(data) {
    return request.get('/user/shopList', data);
  },

  //获取unid-二维码登录
  getAuthorizeToken(data) {
    return request.get('/user/getAuthorizeToken', data);
  },

  //获取unid-二维码登录
  getLoginQrcode(data) {
    return request.get('/user/getLoginQrcode', data);
  },

  //二维码是否扫码登录
  isLogin(data) {
    return request.get('/user/isLogin', data);
  },

  //获取城市用户列表
  cityAdminList(data) {
    return request.get('/admin/cityAdminList', data);
  },

  //获取城市用户列表
  dealUserList(data) {
    return request.get('/user/dealUserList', data);
  },

  //人员列表获取
  areaUsers(data) {
    return request.get('/user/areaUsers', data);
  },

  //获取登录状态
  loginStatus(data) {
    return request.get('/user/loginStatus', data);
  },

  //绑定手机号码
  bindMobile(data) {
    return request.post('/user/bindMobile', data);
  },

  //修改密码
  updatePwd(data) {
    return request.post('/user/updatePwd', data);
  },
};
